import { atom } from "jotai";
import { atomWithRefresh, loadable } from "jotai/utils";

import { Logger } from "@moment/logging";

import { getCache } from "../_interop";

const logger = new Logger("tauri-events");

const $acknowledgedEvents = atom([] as number[]);

const $cacheEvents = atomWithRefresh(async () => {
	logger.debug("Loading events");
	const cache = getCache();
	const events = await cache.pendingEvents.getAll();
	logger.debug("Fetched events", { events });
	return events;
});

export const $tauriEvents = atom(
	(get) => {
		const events = get(loadable($cacheEvents));
		const acknowledged = get($acknowledgedEvents);

		if (events.state === "hasData") {
			logger.debug("Populated events", { all: events.data, acknowledged });

			return events.data.filter((event) => !acknowledged.includes(event.id));
		}

		return [];
	},
	async (get, set, id?: number) => {
		// If an ID is passed through, let's handle that event
		if (id) {
			logger.debug("Acknowledging event", { id });

			// Optimistically remove it from the list so React doesn't try to handle it again
			set($acknowledgedEvents, [...get($acknowledgedEvents), id]);

			// Remove it from the cache
			await getCache().pendingEvents.delete(id);
		}

		// Refresh the cache
		void set($cacheEvents);
	}
);
